import Handlebars from '@sparta.global.vendors/handlebars';

/**
 * helper function to make link - imported from sparta1
 *
 * @param { object } link link
 * @returns { string } safestring link
 */
function linkUtility(link) {
  // return empty string if link object not provided
  if (!link) {
    return '';
  }
  link.CLASS = link.CLASS || ''; // eslint-disable-line no-param-reassign
  const layerClasses = {
    layer: 'spa-ui-layer-link spa-fn',
    popup: 'spa-fn spa-boa-window'
  };
  // handling button
  /* eslint-disable */
  if (link.button) {
    link.CLASS += ' spa-btn';
    var button, buttonsConfig;
    button = link.button;
    buttonsConfig = {
      sizes: {
        default: 'spa-btn--small',
        small: 'spa-btn--small',
        large: 'spa-btn--large',
        engagement: 'spa-btn--engagement'
      },
      skins: {
        default: 'spa-btn--primary',
        primary: 'spa-btn--primary',
        secondary: 'spa-btn--secondary',
        reverse: 'spa-btn--reverse',
        disabled: 'spa-btn--disabled'
      },
      expand: {
        small: 'spa-btn--expand-on-small',
        medium: 'spa-btn--expand-on-medium'
      }
    };
    // handle button skin
    if (button.skin) {
      link.CLASS += ' ' + buttonsConfig.skins[button.skin];
    }
    // handle expand
    if (button.expand) {
      Object.keys(buttonsConfig.expand);
      link.CLASS += ' ' + buttonsConfig.expand[button.expand];
    }

    //handle block
    if (button.block) {
      link.CLASS += ' spa-btn--block';
    }

    // handle button sizes, except for large since it is default
    if (button.size) {
      Object.keys(buttonsConfig.sizes);
      link.CLASS += ' ' + buttonsConfig.sizes[button.size];
    } else {
      link.CLASS += ' ' + buttonsConfig.sizes.default;
    }
  }

  //handling guillemet
  if (link.guillemet) {
    var guillemet = link.guillemet;
    link.CLASS += ' spa-guillemet';
    if (guillemet === 'left') {
      link.CLASS += ' spa-guillemet--left';
    }
  }

  // check if ationType exists
  if (link.actionType) {
    // if options are defined
    if (link.actionType.options) {
      link.actionType.options;
      link.OPTIONS = JSON.stringify(link.actionType.options);
    }

    // handle info, modal, and task layers
    if (link.actionType.type === 'layer') {
      link.REL = link.actionType.options.rel;
      link.CLASS += ' ' + layerClasses[link.actionType.type];

      //Handle for interstitials
      if (link.actionType.options && link.actionType.options.interstitalType !== '') {
        //link.DATA_URL = link.URL;
        link.CLASS += ' spa-ui-layer-interstitial';
        //All non-interstitials, prevent default clicks
      } else {
        link.URL = 'javascript:void(0);';
      }
    }

    // handle popup
    if (link.actionType.type === 'popup') {
      link.CLASS += ' ' + layerClasses[link.actionType.type];
    }
  }

  // trimming leading space on class
  if (link.CLASS.length) {
    link.CLASS = link.CLASS.replace(/^\s+|\s+$/g, '');
  }
  var output = "<a id='" + link.ID + "'" + (link.URL ? " href='" + link.URL + "'" : '') + (link.DATA_URL ? " data-href='" + link.DATA_URL + "'" : '') + (link.CLASS ? " class='" + link.CLASS + "'" : '') + (link.REL ? " rel='" + link.REL + "'" : "") + (link.OPTIONS ? " data-options='" + Handlebars.Utils.escapeExpression(link.OPTIONS) + "'" : "") + (link.TARGET ? " target='" + link.TARGET + "'" : "") + (link.tabIndex ? " tabindex='" + link.tabIndex + "'" : '') + ">" + (link.content !== undefined ? link.content : 'Learn More') + "</a>";
  return new Handlebars.SafeString(output);
  /* eslint-enable */
}

export { linkUtility as default };
